// Equipamiento del vehículo de la reserva: cada vehículo tiene el suyo (Flota) y
// la reserva guarda una copia. Sirve igual para la entrega y para la devolución.
export function equipmentOf(source) {
  const list = source?.vehicle?.equipment || source?.equipment || [];
  return list.filter((e) => e && e.key);
}

export function allChecked(items) {
  return Object.fromEntries(items.map((e) => [e.key, true]));
}

export function groupsOf(items) {
  const groups = [];
  items.forEach((e) => {
    let g = groups.find((x) => x.label === e.group);
    if (!g) {
      g = { id: e.group, label: e.group, items: [] };
      groups.push(g);
    }
    g.items.push({ id: e.key, label: e.label });
  });
  return groups;
}

// Niveles de combustible: la misma escala en la entrega y en la devolución, de lleno a
// reserva (backend: fleet/vehicles.py FUEL_LEVELS, que también da la lectura del GPS).
export const FUEL_LEVELS = ["lleno", "3/4", "1/2", "1/4", "reserva"];

// La devolución del cliente guardaba antes fracciones del depósito («1» … «0»): se leen con su
// equivalente, como el contrato (backend: fleet/vehicles.py fuel_level).
const FUEL_OLD = { 1: "lleno", 0: "reserva" };

export function nivelCombustible(valor) {
  const v = String(valor ?? "").trim();
  if (!v) return "—";
  return FUEL_OLD[v] || v;
}
